import styled from "@emotion/styled";

export const MobileFilterContainer = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100dvh;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.tone.white};
  transform: translateX(200vw);
  transition: transform 350ms ease-in-out;
  z-index: 100010;

  &.open {
    transform: translateX(0);
  }

  > .content-wrapper {
    display: flex;
    flex-direction: column;
    height: calc(100% - 64px);
    padding: ${({ theme }) => theme.space.space16};

    .total-button {
      margin-top: auto;
    }
  }
`;

export const MobileClearAllButton = styled.button`
  display: flex;
  place-items: center;
  padding-inline: ${({ theme }) => theme.space.space16};
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  z-index: 1000;

  &.no-padding {
    padding: 0;
  }
`;
